import React from 'react'

const Label = ({ children }) => {
	return (
		<>
			<div>{children}</div>

			<style jsx>{`
				div {
					font-size: 12px;
				}
			`}</style>
		</>
	)
}

export default Label
